import React from 'react';
import { Modal, Button, ModalHeader, ModalBody } from 'react-bootstrap';
import { IoAlertCircleOutline } from 'react-icons/io5';

export const TwoButtonAlert = ({ details, setDetails }) => {
  const close = () => setDetails({ ...details, status: false });

  return (
    <React.Fragment>
    <Modal
      show={details.status}
      id="removeCartModal"
      style={{
        zIndex:5000000
      }}
      className="fade zoomIn"
      dialogClassName="modal-dialog-centered"
    >
      <ModalBody className="p-md-5">
        <div className="text-center">
          {/* Icon */}
          {details.icon !== false && (
  <div className="text-danger mb-3">
    {typeof details.icon === 'function' ? (
      <details.icon size={48} />
    ) : (
      <IoAlertCircleOutline size={48} />
    )}
  </div>
)}

          {/* Title */}
          <div className="mt-4">
            <h4>{details.title || 'Are you sure?'}</h4>
            <p className="text-muted mx-4 mb-0">
              {details.message || 'Do you really want to proceed?'}
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          {/* Button 1 */}
          <Button
            variant="light"
            className={`btn w-sm ${details.button1Style || ''}`}
            onClick={() => {
              details.onButton1Click?.();
              close();
            }}
          >
            {details.button1Text || (details.onButton2Click ? 'Cancel' : 'Okay')}
          </Button>

          {/* Button 2 - Only if provided */}
          {details.onButton2Click && (
            <Button
              variant="danger"
              className={`btn w-sm btn-hover ${details.button2Style || ''}`}
              id="delete-record"
              onClick={() => {
                details.onButton2Click();
                close();
              }}
            >
              {details.button2Text || 'Confirm'}
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
    </React.Fragment>
  );
};
